export const INSTRUCTIONAL_MODES = Object.freeze({
  I_DO: "I_DO",
  WE_DO: "WE_DO",
  YOU_DO: "YOU_DO",
});

export const INSTRUCTIONAL_MODE_META = Object.freeze({
  [INSTRUCTIONAL_MODES.I_DO]: Object.freeze({
    value: INSTRUCTIONAL_MODES.I_DO,
    label: "I DO",
    actionLabel: "Teacher models",
    icon: "👩‍🏫",
  }),
  [INSTRUCTIONAL_MODES.WE_DO]: Object.freeze({
    value: INSTRUCTIONAL_MODES.WE_DO,
    label: "WE DO",
    actionLabel: "Work together",
    icon: "🤝",
  }),
  [INSTRUCTIONAL_MODES.YOU_DO]: Object.freeze({
    value: INSTRUCTIONAL_MODES.YOU_DO,
    label: "YOU DO",
    actionLabel: "Try and explain",
    icon: "✍️",
  }),
});

export const getInstructionalModeMeta = (value) => {
  const normalized = String(value || "")
    .trim()
    .toUpperCase();

  return INSTRUCTIONAL_MODE_META[normalized] || null;
};

export const getInstructionalFlowModes = (flow) => {
  const summary = Array.isArray(flow?.summary) ? flow.summary : [];

  return summary
    .map((value) => getInstructionalModeMeta(value))
    .filter(Boolean);
};

// Mode data stays as English keys; call this at render time to translate.
export const localizeInstructionalMode = (mode, t) => {
  if (!mode || typeof t !== "function") return mode;

  return {
    ...mode,
    label: t(mode.label),
    actionLabel: t(mode.actionLabel),
  };
};

export const localizeInstructionalModes = (modes, t) =>
  (Array.isArray(modes) ? modes : []).map((mode) =>
    localizeInstructionalMode(mode, t)
  );
